export default __webpack_public_path__ + "static/media/hht1_ep7_minisitcom_02.33cd39f5.png";